<template>
  <div
    class="icon-text-left-wrapper"
    @click="$emit('click', $event)"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <template v-if="iconName == 'icon-plus'">
      <img class="icon-plus-image" :src="isHovered ? iconPlusHover : iconPlusDefault" alt="" />
    </template>
    <template v-if="iconName == 'icon-go-to-map'">
      <img
        class="icon-go-to-map-image"
        :src="isHovered ? iconGoToMapHover : iconGoToMapDefault"
        alt=""
      />
    </template>
    <template v-if="iconName == 'icon-minus'">
      <div class="icon-minus"> </div>
    </template>
    <template v-if="iconName == 'edit-question-logic'">
      <div class="icon-edit-question-logic"> </div>
    </template>
    <template v-if="iconName == 'edit-question-order'">
      <div class="icon-question-order"> </div>
    </template>
    <span class="icon-text">{{ textHeading }}</span>
  </div>
</template>

<script>
  import iconPlusDefault from '../../assets/icons/icon-add-an-answer.png';
  import iconPlusHover from '../../assets/icons/icon-add-an-answer-white.png';
  import iconGoToMapDefault from '../../assets/icons/icon-go-to-map.png';
  import iconGoToMapHover from '../../assets/icons/icon-go-to-map-white.png';

  export default {
    emits: ['click'],
    data () {
      return {
        isHovered: false,
        iconPlusDefault,
        iconPlusHover,
        iconGoToMapDefault,
        iconGoToMapHover
      };
    },
    props: {
      iconName: {
        type: String,
        default: ''
      },
      textHeading: {
        type: String,
        default: ''
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .icon-text-left-wrapper {
    height: 20px;
    cursor: pointer;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .icon-text-left-wrapper .icon-plus,
  .icon-text-left-wrapper .icon-minus,
  .icon-text-left-wrapper .icon-go-to-map,
  .icon-text-left-wrapper .icon-text {
    vertical-align: middle;
  }

  .icon-text-left-wrapper .icon-text {
    margin-right: 5px;
  }

  .icon-plus {
    display: inline-block;
    background-image: url("../../assets/icons/icon-add-an-answer.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 20px; /*or your image's width*/
    height: 20px; /*or your image's height*/
    margin-right: 5px;
    &:hover {
      background-image: url("../../assets/icons/icon-add-an-answer-white.png");
    }
  }

  .icon-plus-image {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    vertical-align: middle;
  }

  .icon-go-to-map-image {
    width: 25px;
    height: 20px;
    margin-right: 5px;
    vertical-align: middle;
    object-fit: contain;
  }

  .icon-minus {
    display: inline-block;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAApFJREFUOBGVVEtoU1EQnXvfM7H10w9CrVgoVKyuBH+bLirYlQXBWEOSVvwskhpoXhrcuJGAqEQwaSpJm2y6KYmLVsGKIghuigjipztLoVJRKlaTutFGkxnnPnglDbWfgfvuZebMeefNzH0C1jCvN1z9S8s32bfKhaaamsVwOIz/g4vKwCV/qKlQLF1FoE6ONTLgE4DYTQAoBDzTQIuMpqJTlXkriDy+gJdI3ASglNDlWCY58N5KcBtGAyzBWSC4Dkx45mTbZafTWbLiy0QurxFggrjUtJbMUGzWAlTufn94e76Ye81kvzPD8SNCCBbLmtXD0xtwIYobcovekUncnVO+tYxYtttnIGen76cGfQor+/oG7Ujijq5rFzZCopKUip1QVStIOM77gwdNoh9/Z50s7t1oMvpSOTZq6XTkJxNGikUMqRydkE5xbR5slKAcZxMwViBhCtBJULOu6TMWwOXrP6oBtnABJLdbsl8SouR6SME+u6360ci92wsKPzIUm/P4jF08Xzad21mPpaIZUEEBeJxnqJ39iLyYjDkFH3knwgL+ea5wylSt3F7j+3Q+X6dz274A6XvZb6rKpuJJPqu1rrES/cN8rj47EP8mScAbEqUT62atApiZz7WzkCmlTPLHTxDBOWZX9diU8Virjj9WSXJ/Y90k12F++uvitc2w9HiDhxl/umqbllB55mRf7A02LyF+5D51ZYfj4+sR9vj795WK+Jab2J1NxSaWidRBkRWQXnF3bjk62hLlF7Kc2OMLOpBwvPKlpiILaJIRJfgutbLWhxK0SZClz9z4Bp6DVkDq4lnaIUAzMunoCytP7SuIlENdyO4roWM8Mp0EdIgBajR4zsQsh54c2FP7dLUf3D9MVQKufpcv1gAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 20px; /*or your image's width*/
    height: 20px; /*or your image's height*/
    margin-right: 5px;

    &:hover {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAZRJREFUOBGVlD1Lw1AUhnNTFYxFoaiLdVE6OKvgoouLIugfkG7FX6Cg+AOcBJ0ddHIRVIqd3AoFEVHooCAIflQ76FA76FCMz0lzY2KwJgce7nvPfc9p0ntzldEibNvuZXkI+uAZbpRSH4z/B8UK5qEEb3AOebiCGhRgomUnDAk4gTLMQru/gHk3ZOEBNkH51x1N0oIGfIIZMvgSrveC8dCXbkqSB7AdWvgjgbcDJFY9C5NxqECnl4wg8GfgFVLOOyJ2qCuzI1sR6gMWavdInBkI2aUqpAOOiBPqFqDQhj8Bcl4qupaFHLof5E8XxKO1wZOvMddxjxiQRl1QZ9HWK4xJsODLpfFLM/WijrLk1Ux4BymOHdRNQdHkSeRXSzATu0uzQOqKjqTjEuTjNqJGztIdjOlGcqpvIRunGf51OIafL4HJCEgsRmmGbxkeQW6GYJAcBTlTKyBbHgrySdgFiR5tkO33gj9ePsRJEhvwhD5ivIYqDIJcH9OwDyn8NUYnwteAu0CTDHIOhkFfbJfoUxq8MAbiG7iDMUR6IaYOAAAAAElFTkSuQmCC");
    }
  }

  .icon-edit-question-logic {
    display: inline-block;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAABGdBTUEAALGPC/xhBQAAAW1JREFUKBVjZEACubm5Mr9+/XIHCrn9//9fAyY1a9Ys/fT0dGegWB9MDJlmZGQsYoEJZGRkOAEN2QJUzAmU+AIUvw/E/2HyhGhGkAKgIQ5AA7YBmW+AdDyQPgJ0xW+QHLEA7CKg5iYg/sLGxmY/ZcoUkEtIBixlZWW8Hz9+tATqXIDPEGD4if7+/VsXmw2srKyXWT59+mQMdA0LMFxOYFMEEwMaYvPv3791MD4yDZQLYmFmZr4MNOgfEBsgS6KzgRZdBIrloIuD+FA5BgZg1J4B4kfZ2dnCMIUgL8PYxNBMIEVAE3uALpL58+fPXqBh8iAxoJfzgLEZBmITA8DRD1IIdFEy0LDZQCZI7DqIBgIVII6eMWPGqrS0NHMguxwojgGA+jrBLgLJzJw5cy6QcgbiSUAMMkwDqIAFGMD+QDYDExOTFJAfiA2D5OAuAilGBkAX1ANdoCUpKRnd0NDwB1kOGxvuIiySO4g1BKQXAIiQo27UDdzjAAAAAElFTkSuQmCC");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 18px; /*or your image's width*/
    height: 13px; /*or your image's height*/
    margin-right: 5px;

    &:hover {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAABGdBTUEAALGPC/xhBQAAARVJREFUKBWVkj1rAkEQhnfhUgSxEjshCCnSiIKFBCyMgaS+FJIfYWVjYZE6jWCdJo2gFlb5BalSWEQsroxYWoeUt3lGXFiXE24HHubjnRlu91Yrx4wxFdJHeIAbK2mt62j35GNb8/wgsgUau8QfcAm/8AMG8htLOvAHO7iDi/zTTieDn7CHqlMOCiOGi0zcwjt3IcfJNPrKCLVMUamN3FETxH+dabLlNsHSJp5/kgUbSKHhiX66ptD3i8dcNH6NMSuQiy4dBanJkcOMoWdI4RuuZBo/gl7eTYd3xCXPGCow9AZb4gSv4ZpYoS/wLfIhZNnrSZFmeUMTSMDaVJpIYlvI8PHJIjeh+QXmcPhqVwuKWdAKWfIPQouzOZWjA54AAAAASUVORK5CYII=");
    }
  }

  .icon-question-order {
    display: inline-block;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAABGdBTUEAALGPC/xhBQAAAh5JREFUOBHtU01oE1EQnnmbZCmhhYBS1JvehF6sNkS8eRI9KiYoVhA2vdSkiBeRsp4EIzaJkCZ7EJRuUmJVFPXgpdeiHjxWJNWD1J9okEYNSbM7zrPusoc1iXcf7M68b+b73r7ZGYQBV0JLHQKkRwgQLZfybxyacJxe9szUzC6OV4lQtwGfJbQL25z8vgLT03m1Y9sPQFB20cjlmbBAsPlQ4lKkr8CXTm0ekd5WivlrkmAWs7OI8L7ert2Se0W+/rbiWvooAGUQcHT/gdjdVy9XvtXqzYNk0znGD4+NR9/1/IJFI/tECeAEH3CvbdMJeZBlWWfZLChKIFYu5e64AvGp1AxXeomfaiKZmpXJcpmF3AtCam7t+FyCLiBsmPM3VpDv5gqATRne3Achlojoiq7rAYfUy7oCfM+foEYeV4pzVSZYvUjemCvgBf/F/y8wQCvLgvIECgIcPq2l97E/5i3yQP9aIWFaYJsWwjEg3KkiPnVEkBsm9Hq9OQLY/SRCkYh5U9+Ia+ftITU8OmSprUJB/+4k+1mx+qHxnMezTkCfw+0drT9Ja63Oj7VGt9Gc1C7u8SM6mMCAcorH86tQxBHDSG7KQCgYjgJBXSBO3jYyNSfZz3JNAOLJ9HEk+3owGB7fvV1trq43ljmwXDHyl/1IXuy3gAR4Cq9yuSd42j4yGCyXsifltHmT/Xy3lZlwiRNGeGBjw7CXr9WfLAV/AbSAu8hE5EYwAAAAAElFTkSuQmCC");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 16px; /*or your image's width*/
    height: 22px; /*or your image's height*/
    margin-right: 5px;

    &:hover {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAM5JREFUOBHtU0kSgzAMCxz7FD7V/gzO/KfPgFvPQaJxkD1l6fRaz7ixLVnuOCElsZzzDKfNUnYhsBt85OkATQBW07rGIAyFNGjdxVUFgQNKgvJDOcw/8ZKSIgFYB38pp+Rd5O4KoYF7eQYRS1n3+zKEp05B2rN2YH0TGqpAA1PMYopZrJzWir+ef6HzDba4BHvy9TbYJlfdn8u8G756bDLADV6HAbz8/A+FqAbCXUnM1ynhRzkB2lKQbF+7e7kqxH2NcP8RbrP4z6ciNkk5LQQSjE95bAR/AAAAAElFTkSuQmCC");
    }
  }
</style>
